import { render, staticRenderFns } from "./SupervisiUmumSeksiChecklist.vue?vue&type=template&id=c4ee6550&scoped=true&"
import script from "./SupervisiUmumSeksiChecklist.vue?vue&type=script&lang=ts&"
export * from "./SupervisiUmumSeksiChecklist.vue?vue&type=script&lang=ts&"
import style0 from "./SupervisiUmumSeksiChecklist.vue?vue&type=style&index=0&id=c4ee6550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ee6550",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VChip,VFileInput,VIcon,VSimpleTable,VTextarea})
